// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"cd49a730","99":"2641219c","146":"60e426cd","175":"f0f7c838","204":"89c49bbf","349":"1b132792","381":"f2f5489c","453":"5a7500f6","479":"e0501527","655":"a7f7c27e","674":"4d7d9c06","681":"9f5bcba6","692":"7274cccf","768":"537ffb29","813":"048e457f","963":"caf511b9"}[chunkId] + ".chunk.js";
};